import React from "react";
import styled from "styled-components";
import fonts from "../../styles/fonts";
import logo from "../../images/logo.png";
import Link from "gatsby-link";
import colors from "../../styles/colors";

const StyledLink = styled(Link)`
  color: ${colors.header};
  text-decoration: none;
`;

const Title = styled.div`
  color: ${colors.header};
  font-family: ${fonts.header};
  font-weight: 700;
  margin-top: -5px;

  @media screen and (max-width: 899px) {
    font-size: 1.5rem;
    width: 337px;
  }
  @media screen and (min-width: 900px) {
    font-size: 1.7rem;
    width: 230px;
  }
`;

const Logo = styled.img`
  display: inline-block;
  vertical-align: middle;

  @media screen and (max-width: 899px) {
    height: 1.32rem;
    margin-top: -5px;
    padding-right: 4px;
  }
  @media screen and (min-width: 900px) {
    height: 1.5rem;
    margin-top: -8px;
    padding-right: 7px;
  }
`;

export default ({ data }) => {
  return (
    <Title>
      <StyledLink to="">
        <Logo src={logo} /> {data.site.siteMetadata.title}
      </StyledLink>
    </Title>
  );
};



// WEBPACK FOOTER //
// ./src/components/layout/Title.js